export const isDateValid = (date: Date) => !isNaN(date.getTime());
